export const overallEvaluationStyles = (_isMobile = false) => {
  const formControlContainerStyles = {
    flexDir: 'column',
  };

  const labelStyles = {
    size: 'sm-semi-bold',
    color: 'secondary-900',
    minWidth: 'unset',
    width: '100%',
  };

  // Use responsive syntax: 'column' on base (mobile), 'row' on md and up
  // This works automatically with Chakra UI based on viewport
  const direction = { base: 'column', md: 'row' };

  const overallEvaluationStyles = {
    radioOptionsDirection: direction,
    styles: {
      direction: direction,
      flexDirection: direction,
      ml: '0px',
      gap: '6px',
    },
    radioStyles: {
      flex: '1',
      variant: 'ats-no-border',
      display: 'flex',
      marginInlineStart: '0px !important',
    },

    radioWrapperStyles: {
      className: 'overall-eval-option',
      alignItems: 'center',
      flexDir: 'row',
      gap: '6px',
      flex: 1,
      border: '1px solid',
      borderColor: 'border-color',
      borderRadius: 'sm',
      justifyContent: 'center',
      py: '6px',
    },

    radioLabelStyles: { size: 'sm', lineHeight: '20px', mb: '0px' },
    radioIconStyles: { width: '18px', height: '18px' },
    labelStyles: { ...labelStyles, marginBottom: '15px' },
    subLabelStyles: { marginBottom: '15px' },
    formControlContainerStyles,
  };

  return overallEvaluationStyles;
};
